module.exports = __webpack_public_path__ + "img/941.1c2beeb8.png";